<template>
  <div class="welfare-components">
    <div class="welfare">
      <div class="jumbotron">
        <img src="../assets/img/welfare/jumbotron.jpg" alt="" class="over_display">
        <img src="../assets/img/welfare/jumbotron_under.jpg" alt="" class="under_display">
      </div>
      <div class="catch-wrapper">
        <img src="../assets/img/welfare/catch.png" alt="安心して勤めていく上で大切なことって？働きやすさ／福利厚生もご注目ください。" width="500px">
      </div>
      <div class="main-contents-wrapper">
        <div class="genre-wrapper">
          <p class="title">
            「子育て」や「介護」にかかわる制度
          </p>
          <div class="main-contents-inner">
            <WelfareCard title="産前産後休暇" :image="require('../assets/img/welfare/card/01.svg')" size="48px" content="産前休暇は、出産予定日の6週間前（双子以上の場合は14週間前)から。産後休暇は、出産の翌日から8週間、取得できます。" />
            <WelfareCard title="育児休暇" :image="require('../assets/img/welfare/card/02.svg')" size="65px" content="お子さんが1歳になるまでの期間、取得することができます。場合により、最長2歳になるまで取得可能です。" />
            <WelfareCard title="育児短時間勤務" :image="require('../assets/img/welfare/card/03.svg')" size="68px" content="3歳未満のお子さんと同居して養育する従業員が対象。1日の勤務時間（所定労働時間）を、10：00〜17：00の6時間にします。" />
            <WelfareCard title="所定外労働の免除" :image="require('../assets/img/welfare/card/04.svg')" size="77px" content="3歳未満のお子さんを養育する従業員が対象。申し出た場合、所定労働時間を超えて労働させることはありません。" />
            <WelfareCard title="時間外労働の制限" :image="require('../assets/img/welfare/card/05.svg')" size="77px" content="小学生未満のお子さんを養育する従業員、または要介護状態の家族を介護する従業員が対象。申し出た場合は、1ヶ月に24時間、1年で150時間を超えて時間外労働をさせることはありません。" />
            <WelfareCard title="看護休暇" :image="require('../assets/img/welfare/card/06.svg')" size="66px" content="小学生未満のお子さんがいる場合、負傷または疾病にかかった場合に取得できます（一人について年間5日。年次有給休暇とは別）。" />
            <WelfareCard title="母性健康管理" :image="require('../assets/img/welfare/card/07.svg')" size="63px" content="妊娠中、および産後1年以内の女性従業員が対象。健康診査などの目的で勤務時間内に通院することが可能です。" />
            <WelfareCard title="介護休業" :image="require('../assets/img/welfare/card/08.svg')" size="97px" content="介護が必要な状態にあるご家族がいる場合に取得可能（介護を必要とする家族一人について93日の範囲内）。" />
            <WelfareCard title="介護休暇" :image="require('../assets/img/welfare/card/09.svg')" size="97px" content="介護が必要な状態にあるご家族がいる場合に取得可能（一人について年間5日。年次有給休暇とは別）。" />
            <WelfareCard title="介護短時間勤務" :image="require('../assets/img/welfare/card/10.svg')" size="97px" content="ご家族を介護する従業員が対象。1日の勤務時間（所定労働時間）を、10：00〜17：00の6時間にします。" />
          </div>
        </div>
        <div class="genre-wrapper">
          <p class="title">
            「生活のサポート」にかかわる制度
          </p>
          <div class="main-contents-inner">
            <WelfareCard title="資格手当" :image="require('../assets/img/welfare/card/11.svg')" size="62px" content="「チーフ資格」「第二種衛生管理者（国家資格）」など。衛生管理者は入社2年目以降が対象。受験希望者は全4回の勉強会に参加できます。合格すると受験費用は会社が負担。" />
            <WelfareCard title="役職手当" :image="require('../assets/img/welfare/card/12.svg')" size="122px" content="「店長」「部長」「課長」「バイヤー」「店長代行」「チーフ」など。昇格に応じて、基本給にくわえて手当も増えていきます。" />
            <WelfareCard title="家族手当" :image="require('../assets/img/welfare/card/13.svg')" size="149px" content="「配偶者」「第一子」「第二子」「第三子」。既婚者かつ扶養家族がいる場合に支給します。" />
            <WelfareCard title="寮・社宅" :image="require('../assets/img/welfare/card/14.svg')" size="128px" content="男子寮があります（月2万2000円・朝・晩の食事あり）。また社宅については、チーフ職以上の既婚者が入居できます。" />
            <WelfareCard title="施設割引" :image="require('../assets/img/welfare/card/15.svg')" size="111px" content="さまざまな提携宿泊施設の割引（休暇などにご家族で利用可）、日本を代表するアミューズメント施設のチケット3000円引きなど。" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WelfareCard from '@/components/welfare/WelfareCard.vue'
export default {
  name: 'Welfare',
  components: {
    WelfareCard
  }
}
</script>
<style scoped lang="scss">
.welfare {
  padding-bottom: 100px;
  &:before {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    left: 0;
    top: 800px;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
  &:after {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    right: 0;
    top: 0;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
}
.jumbotron {
  margin: 0 auto;
  max-width: 1300px;
  width: 100%;
  img {
    vertical-align: middle;
  }
}
.catch-wrapper {
  margin: 0 auto;
  max-width: 900px;
  width: 100%;
  margin-top: -100px;
  text-align: right;
  @media print, screen and (max-width: 900px) {
    margin-top: -10px;
    width: 90%;
  }
  img {
    vertical-align: middle;
  }
}
.main-contents-wrapper {
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  margin-top: 100px;
  @media print, screen and (max-width: 900px) {
    width: 90%;
    margin-top: 50px;
  }
}
.genre-wrapper {
  margin: 0 auto;
  width: 100%;
  margin-top: 50px;
  .title {
    color: #e51c57;
    text-align: center;
    font-size: 18px;
    @media print, screen and (min-width: 415px) {
      &:before {
        content: url('../assets/img/welfare/kagi_first.svg');
        width: 10px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 20px;
      }
      &:after {
        content: url('../assets/img/welfare/kagi_last.svg');
        width: 10px;
        display: inline-block;
        vertical-align: middle;
        margin-left: 20px;
      }
    }
  }
}
.main-contents-inner {
  display: grid;
  margin-top: 50px;
  grid-template-columns: repeat(auto-fit, 280px);
  justify-content: center;
  grid-column-gap: 13px;
}
@media all and (-ms-high-contrast: none) { //ie11ハック
  .main-contents-inner {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
}
</style>
